module.exports = __webpack_public_path__ + "img/no-map.6a48110b.svg";